import SortableItem from './SortableItem';
import SortableList from './SortableList';
import SortableManager from './SortableManager';

var insert = function insert(_ref) {
  var fromList = _ref.fromList,
      fromIndex = _ref.fromIndex,
      toList = _ref.toList,
      toIndex = _ref.toIndex;
  var result = Array.from(toList);

  var _Array$from$splice = Array.from(fromList).splice(fromIndex, 1),
      removed = _Array$from$splice[0];

  result.splice(toIndex, 0, removed);
  return result;
};

var remove = function remove(_ref2) {
  var list = _ref2.list,
      index = _ref2.index;
  var result = Array.from(list);
  result.splice(index, 1);
  return result;
};

var reorder = function reorder(_ref3) {
  var list = _ref3.list,
      startIndex = _ref3.startIndex,
      endIndex = _ref3.endIndex;
  var result = Array.from(list);

  var _result$splice = result.splice(startIndex, 1),
      removed = _result$splice[0];

  result.splice(endIndex, 0, removed);
  return result;
};

export default {
  SortableItem: SortableItem,
  SortableList: SortableList,
  SortableManager: SortableManager,
  insert: insert,
  remove: remove,
  reorder: reorder
};